export const buttonStyle = { backgroundColor: "rgba(0, 0, 0, 0.5)", fontSize: "1.9rem", zIndex: 1000};